import { Component, AfterContentInit, Input, ViewChild } from '@angular/core';
import { OnDestroy } from '@angular/core';
import { HelpElementDTO, ContextHelp, HelpElementType } from './help.dtos';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/AppState';
import { HelpService } from './help.service';
import { WaitLoadingService } from '../waitLoading/wait-loading.service';
import { BaseComponent } from '../baseComponent/base.component';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { OverlayPanel } from 'primeng-lts/overlaypanel';

declare var jQuery: any;

@Component({
  selector: 'plyca-contextHelp',
  templateUrl: 'contextHelp.template.html'
})
export class ContextHelpComponent extends BaseComponent implements AfterContentInit, OnDestroy {

  public helpElements: Array<HelpElementDTO>;
  public searchTags: Array<string>;

  groupedHelp: Array<any>;
  helpElementsCount: number;
  loaded: boolean;
  @ViewChild('op')
  helpPanel: OverlayPanel;

  @Input()
  isModal = false;

  @ViewChild('helpcontainer') helpcontainer;
  searching: boolean;
  constructor(protected store: Store<AppState>,
    private waitService: WaitLoadingService,
    private router: Router,
    protected helpService: HelpService) {
    super();
    this.helpElementsCount = undefined;
    // limpiar ayuda contextual al navegar a un nuevo componente
    this.subscribe(router.events
      .pipe(filter(event => event instanceof NavigationEnd)),
      (event: NavigationEnd) => {
        if (this.helpPanel) {
          this.helpPanel.hide();
        }
      });
  }

  ngAfterContentInit() {


    this.loaded = false;





    this.subscribe(this.store.select('contextHelp'),
      (help: ContextHelp) => {
        console.log('helpTags en el store:' + help.searchTags);

        this.helpElementsCount = 0;

        // Para el elemenresult con los badgets de las etiquetas de ayuda
        this.searchTags = help.searchTags;

      });


    console.log('CONTEXT HELP searchTags: ' + this.searchTags);
  }

  isLoaded() {
    return this.loaded;
  }

  showPanel() {



    this.searching = true;

    this.helpElements = [];

    this.groupedHelp = this.helpService.groupHelp(this.helpElements);
    this.subscribe(
      this.helpService.searchContextHelpTags(this.searchTags)
        .pipe(

          map(
            (contens: any) => {


              this.helpElements = contens;
              if (this.helpElements) {
                this.helpElementsCount = this.helpElements.filter(
                  el => el.type !== HelpElementType.AYUDA
                ).length;
              } else {
                this.helpElementsCount = 0;
              }
              this.groupedHelp = this.helpService.groupHelp(this.helpElements);
              this.searching = false;

            })
        ));










    console.log('ABIERTO');

  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
